import { useCallback, useEffect, useState } from "react";
import SubmissionsTable from "@/components/SubmissionsTable";
import api from "@/lib/api";

export default function RunnerPanel() {
  const [subs, setSubs] = useState([]);

  const refresh = useCallback(() => {
    api.get("/submissions").then((r) => setSubs(r.data)).catch(() => {});
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return (
    <div className="space-y-4" data-testid="runner-panel">
      <div>
        <h2 className="font-display text-2xl font-bold tracking-tight">Assigned Jobs</h2>
        <p className="mt-1 text-sm text-muted-foreground">Jobs where you are tagged as the runner. Update statuses as you progress.</p>
      </div>
      <SubmissionsTable submissions={subs} onRefresh={refresh} canUpdateStatus />
    </div>
  );
}
